"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var QuickLayoutAuto = function QuickLayoutAuto(_ref) {
  var children = _ref.children,
      min = _ref.min,
      gap = _ref.gap,
      className = _ref.className;
  var classes = (0, _classnames.default)('QuickLayoutAuto', className && className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: {
      display: 'grid',
      gridTemplateColumns: "repeat(auto-fit, minmax(".concat(min, ", 1fr))"),
      gridGap: gap
    }
  }, children);
};

QuickLayoutAuto.defaultProps = {
  min: '150px',
  gap: '1rem'
};
var _default = QuickLayoutAuto;
exports.default = _default;